import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {StatsTabModel} from "../stats.tab-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionStatsPageLinkModel} from "../../../../../containers/competition-container/pages/stats-page/models/competition-stats-page.link-model";

export class CompetitionStatsPageTabModel extends StatsTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionStatsPageLinkModel {
    const linkModel: CompetitionStatsPageLinkModel = new CompetitionStatsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.stats;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }
  get elementId(): String {
    return 'navigation-tabs_competition_stats';
  }
}
